export default {
  storeNamespace: 'reference_log',
  authFeature: 'reference-log',
  fields: [{
      name: 'reference',
      label: "Référence unique",
      detailLink: 'ReferenceDetail',
      formatter: (context, value) => value ? value.product.name + ' - ' + value.internal_code : null
    },
    {
      name: 'renting',
      label: "Commande",
      detailLink: 'RentingDetail',
      formatter: (context, value) => value ? value.renting_number : null
    },
    {
      name: 'agency',
      label: "Agence",
      inDetail: true,
      detailLink: 'AgencyDetail',
      formatter: (context, value) => value && value.number && value.name ? value.number + ' - ' + value.name : null
    },
    {
      name: 'business',
      label: "Affaire",
      inDetail: true,
      detailLink: 'BusinessDetail',
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'transfer',
      label: "Demande de transfert",
      detailLink: 'TransferDetail',
      formatter: (context, value) => value ? value.transfer_number : null
    },
    {
      name: 'start_date',
      label: "Date de début",
      inDetail: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'end_date',
      label: "Date de fin",
      inDetail: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      // Arrêt de facturation posé par une demande de retour (Chronopost, ESM…) avant la
      // réception : affiché sous la date de fin dans l'historique de la référence.
      name: 'billing_end_date',
      label: "Fin de facturation",
      inDetail: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'context',
      label: "Statut",
      inDetail: true,
      // formatter: (context, value) => value ? value : null
    },
    {
      name: 'external_maintenance',
      label: "Maintenance externe",
      detailLink: 'ExternalMaintenanceDetail',
      formatter: (context, value) => value ? value.id : null
    },
    {
      name: 'duration',
      label: "Durée en jours",
      inDetail: true,
    },
    {
      name: 'renting_total_price',
      label: "Prix",
      inDetail: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
    },
    {
      name: 'created_at',
      label: "Date de création",
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/ReferenceLog/config.js